import { formatLotExpiration } from "./lot-expiration";

interface LineItemLot {
  lotNumber: string | null;
  expirationDate: Date | string | null;
  quantity: number;
}

interface ItemWithLots {
  externalId: string;
  lots?: LineItemLot[];
}

export function getLotsForExpandedItem(
  expandedItems: readonly (ItemWithLots & { quantity: number })[],
  expansionIndex: number,
): { lot: LineItemLot; units: number }[] {
  const item = expandedItems[expansionIndex];
  if (!item?.lots?.length) {
    return [];
  }

  let firstUnit = 0;
  for (let i = 0; i < expansionIndex; i++) {
    const earlier = expandedItems[i];
    if (earlier?.externalId === item.externalId) {
      firstUnit += earlier.quantity;
    }
  }
  const endUnit = firstUnit + item.quantity;

  const lots: { lot: LineItemLot; units: number }[] = [];
  let lotStart = 0;
  for (const lot of item.lots) {
    const lotEnd = lotStart + lot.quantity;
    const units = Math.min(endUnit, lotEnd) - Math.max(firstUnit, lotStart);
    if (units > 0) {
      lots.push({ lot, units });
    }
    lotStart = lotEnd;
  }
  return lots;
}

export function getLotNumbers(items: readonly ItemWithLots[]): string[] {
  const lotNumbers = new Set<string>();
  for (const item of items) {
    for (const lot of item.lots ?? []) {
      if (lot.lotNumber) {
        lotNumbers.add(lot.lotNumber);
      }
    }
  }
  return Array.from(lotNumbers);
}

export function getLotExpirations(items: readonly ItemWithLots[]): string[] {
  const expirations = new Set<string>();
  for (const item of items) {
    for (const lot of item.lots ?? []) {
      const formatted = formatLotExpiration(lot.expirationDate);
      if (formatted) {
        expirations.add(formatted);
      }
    }
  }
  return Array.from(expirations);
}
